var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseDrawerNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69307 16.7395V4.16138C2.69307 3.66536 2.27275 3.26294 1.75479 3.26294C1.23682 3.26294 0.816895 3.66536 0.816895 4.16138V16.7395C0.816895 17.2374 1.23721 17.6379 1.75518 17.6379C2.27314 17.6379 2.69307 17.2374 2.69307 16.7395ZM11.4536 14.587L7.85986 11.3489H17.3755C17.895 11.3489 18.3169 10.9483 18.3169 10.4504C18.3169 9.95256 17.8966 9.58569 17.3786 9.58569H7.85986L11.4528 6.34645C11.6495 6.1698 11.7485 5.9313 11.7485 5.69246C11.7485 5.47137 11.6642 5.25036 11.4931 5.07703C11.1389 4.71556 10.5451 4.69819 10.1678 5.03844L4.85135 9.83011C4.47268 10.1693 4.47268 10.7985 4.85135 11.1381L10.1678 15.9297C10.5452 16.2702 11.1388 16.2526 11.4931 15.8912C11.8521 15.4967 11.8325 14.9277 11.4536 14.587Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_3059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 19.1667,
    fill: "white",
    transform: "translate(0.816895 0.867065)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDrawerNavigation);
export default __webpack_public_path__ + "static/media/close-drawer-navigation.54f1625cff8f9732b107b1e98ea3fea0.svg";
export { ForwardRef as ReactComponent };